import { IconButton } from "@material-ui/core";
import styled from "styled-components";

export const ClearButton = styled(IconButton)`
  color: ${({ theme }) => theme.palette.darkred} !important;
`;
